import { render, staticRenderFns } from "./choiceRender.vue?vue&type=template&id=685d4759&scoped=true&"
import script from "./choiceRender.vue?vue&type=script&lang=js&"
export * from "./choiceRender.vue?vue&type=script&lang=js&"
import style0 from "./choiceRender.vue?vue&type=style&index=0&id=685d4759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d4759",
  null
  
)

export default component.exports